import React from 'react';
import { Image } from "@uncinc/uncinc-react-kitchen-sink";

import {
  CoreLink,
} from '../../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
} from '../../../../config/constants';

import './style.scss';

const ParagraphCardsCard = ({ entity }) => {
  const backgroundImageMobile = entity.getIn(['field_media', 0, 'styles', 'card'], null);
  const backgroundImage = entity.getIn(['field_media', 0, 'styles', 'card'], null);
  const link = entity.getIn(['field_link', 0, 'alias']) || entity.getIn(['field_link', 0, 'uri']);
  const title = entity.getIn(['field_link', 0, 'title']);

  return (
    <div className="Card moving-arrow--proxy">
      <CoreLink to={link} className="overlapping-link" />
      {backgroundImage && backgroundImageMobile && (
        <Image
          className="Card__background"
          lazyload
          src={{
            [SCREEN_MOBILE]: backgroundImageMobile,
            [SCREEN_TABLET]: backgroundImage,
          }}
        />
      )}
      <div className="Card__content">
        <h3 className="Card__content__title">
          <CoreLink to={link} title={title} />
        </h3>
        <CoreLink to={link} className="Card__content__arrow icon-arrow-right icon-before icon-after moving-arrow icon-variant-4" />
      </div>
    </div>
  );
};

export default ParagraphCardsCard;
